import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Plus, Edit2, Trash2, Scissors } from 'lucide-react';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-SG', { style: 'currency', currency: 'SGD' }).format(amount || 0);
};

const alterationStatusConfig = {
  pending: { label: 'Pending', className: 'bg-slate-500/20 text-slate-600 border-slate-500/30' },
  in_progress: { label: 'In Progress', className: 'bg-blue-500/20 text-blue-600 border-blue-500/30' },
  completed: { label: 'Completed', className: 'bg-green-500/20 text-green-600 border-green-500/30' },
};

const OrderAlterationsTab = ({ orderData, onOpenAlterationDialog, onDeleteAlteration }) => {
  return (
    <Card className="bg-white border border-slate-200/50 shadow-sm">
      <CardHeader className="border-b border-slate-100 flex flex-row items-center justify-between">
        <CardTitle className="text-lg">Alterations</CardTitle>
        <Button onClick={() => onOpenAlterationDialog()}>
          <Plus className="w-4 h-4 mr-2" />
          Add Alteration
        </Button>
      </CardHeader>
      <CardContent className="p-0">
        {!orderData.alterations?.length ? (
          <div className="p-8 text-center text-slate-500">
            <Scissors className="w-12 h-12 mx-auto mb-3 opacity-50" />
            <p>No alterations recorded</p>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="text-xs uppercase">Description</TableHead>
                <TableHead className="text-xs uppercase">Garment</TableHead>
                <TableHead className="text-xs uppercase">Cost</TableHead>
                <TableHead className="text-xs uppercase">Status</TableHead>
                <TableHead className="text-xs uppercase w-24">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {orderData.alterations.map((alteration) => (
                <TableRow key={alteration.alteration_id}>
                  <TableCell className="font-medium">{alteration.description}</TableCell>
                  <TableCell>{alteration.garment_ref || '—'}</TableCell>
                  <TableCell>{formatCurrency(alteration.cost)}</TableCell>
                  <TableCell>
                    <Badge variant="outline" className={alterationStatusConfig[alteration.status]?.className}>
                      {alterationStatusConfig[alteration.status]?.label || alteration.status}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-1">
                      <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onOpenAlterationDialog(alteration)}>
                        <Edit2 className="w-4 h-4" />
                      </Button>
                      <Button variant="ghost" size="icon" className="h-8 w-8 text-red-500" onClick={() => onDeleteAlteration(alteration.alteration_id)}>
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default OrderAlterationsTab;